exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-checkbox[data-v-194bc08f] {\n\tpadding: 2px 0 0 0;\n}\n.ass-border-bottom[data-v-194bc08f] {\n\t/* border-bottom: 1px solid rgba(255, 255, 255, 1); */\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.ass-background-color[data-v-194bc08f] {\n\tbackground-color: rgba(0, 0, 0, 0.035);\n}\n", ""]);

// exports
